/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


expocadfx.setupLanguageSelection = function( menu) {
	'use strict';
	var config = expocadfx.config;
    var data = expocadfx.fxData;
	var localStorage = expocadfx.localStorage;
    var txt = expocadfx.txt;
    var elem = expocadfx.element;
	
	var doc = document;
	
	var span = null;
	
	function saveLanguagePreference( evt) {
		var ls = localStorage.storageAvailable( "localStorage");
		if( ls) {
			ls.setItem( "languagePreference", config.languages[evt.target.value].file);
		}
		location.reload();
	}
    

	var menuItem = doc.createElement( "div");
	menuItem.style.lineHeight = "1.2em";
	menuItem.style.marginTop = "6px";
	menuItem.style.marginBottom = "4px";
	menuItem.textContent = txt.LANGUAGE_PREFERENCE;
	menu.appendChild( menuItem);

	menuItem = doc.createElement( "div");
	menuItem.style.fontSize = "14px";
	menuItem.style.lineHeight = "1.2em";
	menuItem.style.marginLeft = "10px";
	span = doc.createElement( "span");
	//span.className = "icon icon-reload";
	//span.textContent = txt.REFRESH_REQUIRED;
	menuItem.appendChild( span);
	menu.appendChild( menuItem);

	menuItem = doc.createElement( "select");
	menuItem.setAttribute( "id", "userlanguage");
	menu.appendChild( menuItem);
	
	config.languages.forEach( function( language, index) {
		menuItem.appendChild( elem.filterItem( index, language.name, 
												( language.file === data.languagePreference) ));
	
	});
	
	menuItem.addEventListener( "change", saveLanguagePreference);
	
};